export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AddOrganizationToStructureInput = {
  /** ID of organization */
  organizationId: Scalars['String']['input'];
  /** ID of structure */
  structureId: Scalars['String']['input'];
};

export type AddOrganizationToStructurePayload = {
  __typename?: 'AddOrganizationToStructurePayload';
  success: Scalars['Boolean']['output'];
};

export type AddUserToStructureInput = {
  /** ID of structure */
  structureId: Scalars['String']['input'];
  /** ID of user */
  userId: Scalars['String']['input'];
};

export type AddUserToStructurePayload = {
  __typename?: 'AddUserToStructurePayload';
  success: Scalars['Boolean']['output'];
};

export type Annotation = {
  __typename?: 'Annotation';
  /** Full name of the user who created the annotation. */
  authorFullName?: Maybe<Scalars['String']['output']>;
  /** ID of the user who created the annotation. */
  authorId: Scalars['ID']['output'];
  /** Content of the annotation. */
  content: Scalars['String']['output'];
  /** Timestamp of the annotation creation. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the document this annotation belongs to. */
  documentId: Scalars['ID']['output'];
  /** ID of the annotation. */
  id: Scalars['ID']['output'];
  /** Whether this annotation is a reply to another annotation. */
  isReply: Scalars['Boolean']['output'];
  /** List of mentioned users in this annotation. */
  mentions: Array<Mention>;
  /** Page number where the annotation is placed. */
  pageNumber: Scalars['Float']['output'];
  /** Parent annotation if this is a reply. */
  parent?: Maybe<Annotation>;
  /** Position of the annotation on the page. */
  position: AnnotationPosition;
  /** List of replies to this annotation. */
  replies: Array<Annotation>;
};

export type AnnotationPagination = {
  __typename?: 'AnnotationPagination';
  /** List of nodes that matched the query. */
  nodes: Array<Annotation>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type AnnotationPosition = {
  __typename?: 'AnnotationPosition';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type AnnotationPositionInput = {
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type AnnotationsSort = {
  direction: SortDirection;
  field: AnnotationsSortField;
};

export enum AnnotationsSortField {
  CREATED_AT = 'CREATED_AT'
}

export type ArchiveDirectoryInput = {
  /** ID of the directory to create package of. */
  id: Scalars['ID']['input'];
};

export type ArchiveDirectoryPayload = {
  __typename?: 'ArchiveDirectoryPayload';
  key: Scalars['String']['output'];
};

export type BatchIndexPayload = {
  __typename?: 'BatchIndexPayload';
  /** Number of files that were already indexed. */
  alreadyIndexed: Scalars['Int']['output'];
  /** List of error messages encountered during batch indexing. */
  errors: Array<Scalars['String']['output']>;
  /** Number of files that were queued for indexing. */
  queuedFiles: Scalars['Int']['output'];
  /** Total number of files that matched batch indexing criteria. */
  totalFiles: Scalars['Int']['output'];
};

export type ChangePasswordInput = {
  /** Current password of the authenticated user. */
  currentPassword: Scalars['String']['input'];
  /** New password. */
  newPassword: Scalars['String']['input'];
};

export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** Indicates whether password was changed successfully. */
  success: Scalars['Boolean']['output'];
};

export enum ConversionTargetFileFormat {
  PDF = 'PDF'
}

export type ConvertSvgInput = {
  /** Uploaded svg file */
  fileToken: Scalars['String']['input'];
  /** Target format */
  format: ConversionTargetFileFormat;
};

export type ConvertSvgPayload = {
  __typename?: 'ConvertSvgPayload';
  fileConversion: FileConversionModel;
};

export type CopyDestinationStructureIdInput = {
  /** Id of the parent struct to insert the copy. */
  parentId: Scalars['ID']['input'];
  /** SVG polygon path of structure. */
  svgPolygonPath?: InputMaybe<Scalars['String']['input']>;
};

export type CopyStructureInput = {
  /** IDs of the destination structs. */
  destinationStructures: Array<CopyDestinationStructureIdInput>;
  /** ID of structure to update. */
  originStructureId: Scalars['ID']['input'];
};

export type CopyStructuresPayload = {
  __typename?: 'CopyStructuresPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateAnnotationInput = {
  content: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  mentions?: InputMaybe<Array<MentionInput>>;
  pageNumber: Scalars['Float']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  position: AnnotationPositionInput;
};

export type CreateAnnotationPayload = {
  __typename?: 'CreateAnnotationPayload';
  annotation: Annotation;
};

export type CreateDirectoryInput = {
  /** Name of the directory. */
  name: Scalars['String']['input'];
  /** ID of the parent directory to add directory into. */
  parentId: Scalars['String']['input'];
};

export type CreateDirectoryPayload = {
  __typename?: 'CreateDirectoryPayload';
  directory: Directory;
};

export type CreateFileInput = {
  /** ID of the directory to add file into. */
  directoryId: Scalars['String']['input'];
  /** File upload token. */
  fileUploadToken: Scalars['String']['input'];
};

export type CreateFilePayload = {
  __typename?: 'CreateFilePayload';
  file: File;
};

export type CreateFileUploadInput = {
  /** Name of the file to upload. */
  fileName: Scalars['String']['input'];
  /** Size of the file to upload. */
  fileSize: Scalars['Float']['input'];
};

export type CreateFileUploadPayload = {
  __typename?: 'CreateFileUploadPayload';
  /** Fields to include in the form. */
  fields: Array<Entry>;
  /** Upload token to use in another mutations for file assigment. */
  uploadToken: Scalars['String']['output'];
  /** Url to send form data into. */
  url: Scalars['String']['output'];
};

export type CreateOrganizationInput = {
  /** Name of the organization. */
  name: Scalars['String']['input'];
};

export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  organization: Organization;
};

export type CreateReferencesToStructureInput = {
  /** ID of structure to create reference to. */
  originStructureId: Scalars['ID']['input'];
  /** IDs of the destination structs. */
  pointers: Array<StructurePointer>;
};

export type CreateStageInput = {
  /** Name of the stage. */
  name: Scalars['String']['input'];
  /** ID of the structure to add stage into. */
  structureId: Scalars['String']['input'];
};

export type CreateStagePayload = {
  __typename?: 'CreateStagePayload';
  stage: Stage;
};

export type CreateStageRevisionInput = {
  /** Name of the stage revision. */
  name: Scalars['String']['input'];
  /** ID of the stage to add revision into. */
  stageId: Scalars['String']['input'];
};

export type CreateStageRevisionPayload = {
  __typename?: 'CreateStageRevisionPayload';
  stageRevision: StageRevision;
};

export type CreateStructureInput = {
  /** Uploaded background file token to assign into structure. */
  backgroundFileUploadToken?: InputMaybe<Scalars['String']['input']>;
  /** Description of the structure. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Floor number of the structure. */
  floorNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Uploaded interactive file token to assign into structure. */
  interactiveFileUploadToken?: InputMaybe<Scalars['String']['input']>;
  /** Name of the structure. */
  name: Scalars['String']['input'];
  /** ID of the parent structure. */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** SVG polygon path of structure. */
  svgPolygonPath?: InputMaybe<Scalars['String']['input']>;
  /** Type of the structure. */
  type?: InputMaybe<StructureType>;
};

export type CreateStructurePayload = {
  __typename?: 'CreateStructurePayload';
  structure: Structure;
};

export type CreateStructureReferencesPayload = {
  __typename?: 'CreateStructureReferencesPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateStructureRevisionInput = {
  /** Uploaded file tokens to assign into revision. */
  fileUploadTokens: Array<Scalars['String']['input']>;
  /** Name of the structure revision. */
  name: Scalars['String']['input'];
  /** ID of the structure to add revision into. */
  structureId: Scalars['String']['input'];
};

export type CreateStructureRevisionPayload = {
  __typename?: 'CreateStructureRevisionPayload';
  structureRevision: StructureRevision;
};

export type CreateUserInput = {
  /** IDs of the structs that user will administrate. */
  editorOfStrucks: Array<StructIdInput>;
  /** Email of the user. */
  email: Scalars['String']['input'];
  /** Full name of the user. */
  fullName: Scalars['String']['input'];
  /** Is new user admin. */
  isAdmin: Scalars['Boolean']['input'];
  /** ID of the assigned organization. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  user: User;
};

export type DeleteAnnotationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAnnotationPayload = {
  __typename?: 'DeleteAnnotationPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteDirectoryInput = {
  /** ID of the directory to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteDirectoryPayload = {
  __typename?: 'DeleteDirectoryPayload';
  /** Indicates whether stage was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteFileInput = {
  /** ID of the file to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteFilePayload = {
  __typename?: 'DeleteFilePayload';
  /** Indicates whether stage was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationInput = {
  /** ID of organization to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  /** Indicates whether organization was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteStageInput = {
  /** ID of the stage to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteStagePayload = {
  __typename?: 'DeleteStagePayload';
  /** Indicates whether stage was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteStageRevisionInput = {
  /** ID of the stage to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteStageRevisionPayload = {
  __typename?: 'DeleteStageRevisionPayload';
  /** Indicates whether stage was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteStructureFilesInput = {
  /** When true, updates the files prepared for manual swapping/remapping. When false, updates the currently active files. */
  fileType?: StructureFileType;
  /** ID of structure to update. */
  id: Scalars['ID']['input'];
};

export type DeleteStructureFilesPayload = {
  __typename?: 'DeleteStructureFilesPayload';
  structure: Structure;
};

export type DeleteStructureInput = {
  /** ID of the structure to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteStructurePayload = {
  __typename?: 'DeleteStructurePayload';
  /** Indicates whether structure was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteStructureRevisionInput = {
  /** ID of structure-revision to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteStructureRevisionPayload = {
  __typename?: 'DeleteStructureRevisionPayload';
  /** Indicates whether structure-revision was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteSubtreeStructuresInput = {
  /** IDs of the structures to delete. */
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteSubtreeStructuresPayload = {
  __typename?: 'DeleteSubtreeStructuresPayload';
  /** Indicates whether structures were deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type DeleteUserInput = {
  /** ID of user to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** Indicates whether user was deleted successfully. */
  success: Scalars['Boolean']['output'];
};

export type Directory = {
  __typename?: 'Directory';
  /** Ancestors of the directory from the oldest to the newest. */
  ancestors: Array<Directory>;
  /** Children directories of the directory. */
  children: DirectoryPagination;
  /** Timestamp of the directory creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Files assigned to the directory. */
  files: FilePagination;
  /** ID of the directory. */
  id: Scalars['ID']['output'];
  /** Name of the directory. */
  name?: Maybe<Scalars['String']['output']>;
  /** Stage revision related to the directory. */
  stageRevision: StageRevision;
};


export type DirectoryChildrenArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: DirectorySort;
};


export type DirectoryFilesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: FileSort;
};

export type DirectoryPagination = {
  __typename?: 'DirectoryPagination';
  /** List of nodes that matched the query. */
  nodes: Array<Directory>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type DirectorySort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: DirectorySortField;
};

export enum DirectorySortField {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME'
}

export type Entry = {
  __typename?: 'Entry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type File = {
  __typename?: 'File';
  /** Path of the compressed PDF version of the file. */
  compressedPath?: Maybe<Scalars['String']['output']>;
  /** Signed URL of the compressed PDF version of the file. */
  compressedUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the file creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Directory that contains this file. */
  directory?: Maybe<Directory>;
  /** ID of the file. */
  id: Scalars['ID']['output'];
  /** Mime type of the file. */
  mimeType: Scalars['String']['output'];
  /** Name of the file. */
  name: Scalars['String']['output'];
  /** OpenAI file ID used to reference this file in the vector store. */
  openaiFileId?: Maybe<Scalars['String']['output']>;
  /** Size of the file. */
  size: Scalars['Int']['output'];
  /** ID of the structure this file belongs to. */
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Url of the file. */
  url: Scalars['String']['output'];
  /** Last AI indexing error message for this file. */
  vectorIndexError?: Maybe<Scalars['String']['output']>;
  /** Vector index status of the file for AI search (PENDING/PROCESSING/INDEXED/ERROR). */
  vectorIndexStatus?: Maybe<FileVectorIndexStatus>;
  /** Timestamp when the file was indexed in the AI vector store. */
  vectorIndexedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FileConversionModel = {
  __typename?: 'FileConversionModel';
  /** Converted file url. */
  convertedFileUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp of file_conversion creation. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the file_conversion. */
  id: Scalars['ID']['output'];
  /** Job status of the convert file. */
  jobStatus?: Maybe<Scalars['String']['output']>;
};

export type FilePagination = {
  __typename?: 'FilePagination';
  /** List of nodes that matched the query. */
  nodes: Array<File>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type FileSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: FileSortField;
};

export enum FileSortField {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME',
  SIZE = 'SIZE'
}

/** AI indexing status of a file in OpenAI vector store */
export enum FileVectorIndexStatus {
  ERROR = 'ERROR',
  INDEXED = 'INDEXED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export type FinishOnboardingPayload = {
  __typename?: 'FinishOnboardingPayload';
  user: User;
};

export type LoginInput = {
  /** Email of the user. */
  email: Scalars['String']['input'];
  /** Password of the user. */
  password: Scalars['String']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** Token that should be passed with following requests to authenticate user. */
  token: Scalars['String']['output'];
  /** Logged user. */
  user: User;
};

export type Mention = {
  __typename?: 'Mention';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type MentionInput = {
  /** User email */
  email: Scalars['String']['input'];
  /** User ID */
  id: Scalars['ID']['input'];
  /** User full name */
  value: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addOrganizationToStructure: AddOrganizationToStructurePayload;
  addUserToStructure: AddUserToStructurePayload;
  archiveDirectory: ArchiveDirectoryPayload;
  /** Queue batch indexing jobs for existing GENERAL_MODE PDF files in one or all investments. */
  batchIndexExistingFiles: BatchIndexPayload;
  changePassword: ChangePasswordPayload;
  convertSvg: ConvertSvgPayload;
  copyStructures: CopyStructuresPayload;
  createAnnotation: CreateAnnotationPayload;
  createDirectory: CreateDirectoryPayload;
  createFile: CreateFilePayload;
  createFileUpload: CreateFileUploadPayload;
  createOrganization: CreateOrganizationPayload;
  createStage: CreateStagePayload;
  createStageRevision: CreateStageRevisionPayload;
  createStructure: CreateStructurePayload;
  createStructureReferences: CreateStructureReferencesPayload;
  createStructureRevision: CreateStructureRevisionPayload;
  /** Create an OpenAI vector store for a given root structure (investment). */
  createStructureVectorStore: Structure;
  createUser: CreateUserPayload;
  deleteAnnotation: DeleteAnnotationPayload;
  deleteDirectory: DeleteDirectoryPayload;
  deleteFile: DeleteFilePayload;
  deleteOrganization: DeleteOrganizationPayload;
  deleteStage: DeleteStagePayload;
  deleteStageRevision: DeleteStageRevisionPayload;
  deleteStructure: DeleteStructurePayload;
  deleteStructureFiles: DeleteStructureFilesPayload;
  deleteStructureRevision: DeleteStructureRevisionPayload;
  deleteSubtreeStructures: DeleteSubtreeStructuresPayload;
  deleteUser: DeleteUserPayload;
  finishOnboarding: FinishOnboardingPayload;
  login: LoginPayload;
  removeOrganizationFromStructure: RemoveOrganizationFromStructurePayload;
  removeUserFromStructure: RemoveUserFromStructurePayload;
  resetPassword: ResetPasswordPayload;
  /** Retry AI indexing for a single file (e.g. when previous attempt failed). */
  retryFileIndexing: RetryPayload;
  sendContactEmail: SendContactEmailPayload;
  setNewPassword: SetNewPasswordPayload;
  setStageAsExecutive: SetStageAsExecutivePayload;
  swapStructureFile: SwapStructureFilePayload;
  updateAnnotation: UpdateAnnotationPayload;
  updateDirectory: UpdateDirectoryPayload;
  updateFile: UpdateFilePayload;
  updateOrganization: UpdateOrganizationPayload;
  updateStage: UpdateStagePayload;
  updateStageRevision: UpdateStageRevisionPayload;
  updateStructure: UpdateStructurePayload;
  updateStructureFiles: UpdateStructureFilesPayload;
  updateStructureFinishingScheme: UpdateStructureFinishingSchemePayload;
  updateStructureRevision: UpdateStructureRevisionPayload;
  updateUser: UpdateUserPayload;
};


export type MutationAddOrganizationToStructureArgs = {
  input: AddOrganizationToStructureInput;
};


export type MutationAddUserToStructureArgs = {
  input: AddUserToStructureInput;
};


export type MutationArchiveDirectoryArgs = {
  input: ArchiveDirectoryInput;
};


export type MutationBatchIndexExistingFilesArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConvertSvgArgs = {
  input: ConvertSvgInput;
};


export type MutationCopyStructuresArgs = {
  input: CopyStructureInput;
};


export type MutationCreateAnnotationArgs = {
  input: CreateAnnotationInput;
};


export type MutationCreateDirectoryArgs = {
  input: CreateDirectoryInput;
};


export type MutationCreateFileArgs = {
  input: CreateFileInput;
};


export type MutationCreateFileUploadArgs = {
  input: CreateFileUploadInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateStageArgs = {
  input: CreateStageInput;
};


export type MutationCreateStageRevisionArgs = {
  input: CreateStageRevisionInput;
};


export type MutationCreateStructureArgs = {
  input: CreateStructureInput;
};


export type MutationCreateStructureReferencesArgs = {
  input: CreateReferencesToStructureInput;
};


export type MutationCreateStructureRevisionArgs = {
  input: CreateStructureRevisionInput;
};


export type MutationCreateStructureVectorStoreArgs = {
  structureId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteAnnotationArgs = {
  input: DeleteAnnotationInput;
};


export type MutationDeleteDirectoryArgs = {
  input: DeleteDirectoryInput;
};


export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteStageArgs = {
  input: DeleteStageInput;
};


export type MutationDeleteStageRevisionArgs = {
  input: DeleteStageRevisionInput;
};


export type MutationDeleteStructureArgs = {
  input: DeleteStructureInput;
};


export type MutationDeleteStructureFilesArgs = {
  input: DeleteStructureFilesInput;
};


export type MutationDeleteStructureRevisionArgs = {
  input: DeleteStructureRevisionInput;
};


export type MutationDeleteSubtreeStructuresArgs = {
  input: DeleteSubtreeStructuresInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRemoveOrganizationFromStructureArgs = {
  input: RemoveOrganizationFromStructureInput;
};


export type MutationRemoveUserFromStructureArgs = {
  input: RemoveUserFromStructureInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRetryFileIndexingArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationSendContactEmailArgs = {
  input: SendContactEmailInput;
};


export type MutationSetNewPasswordArgs = {
  input: SetNewPasswordInput;
};


export type MutationSetStageAsExecutiveArgs = {
  input: SetStageAsExecutiveInput;
};


export type MutationSwapStructureFileArgs = {
  input: SwapStructureFileInput;
};


export type MutationUpdateAnnotationArgs = {
  input: UpdateAnnotationInput;
};


export type MutationUpdateDirectoryArgs = {
  input: UpdateDirectoryInput;
};


export type MutationUpdateFileArgs = {
  input: UpdateFileInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateStageArgs = {
  input: UpdateStageInput;
};


export type MutationUpdateStageRevisionArgs = {
  input: UpdateStageRevisionInput;
};


export type MutationUpdateStructureArgs = {
  input: UpdateStructureInput;
};


export type MutationUpdateStructureFilesArgs = {
  input: UpdateStructureFilesInput;
};


export type MutationUpdateStructureFinishingSchemeArgs = {
  input: UpdateStructureFinishingSchemeInput;
};


export type MutationUpdateStructureRevisionArgs = {
  input: UpdateStructureRevisionInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type Organization = {
  __typename?: 'Organization';
  /** Timestamp of the organization creation. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the organization. */
  id: Scalars['ID']['output'];
  /** Name of the organization. */
  name: Scalars['String']['output'];
  /** Users assigned to the organization. */
  users: UserPagination;
};


export type OrganizationUsersArgs = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: UserSort;
};

export type OrganizationPagination = {
  __typename?: 'OrganizationPagination';
  /** List of nodes that matched the query. */
  nodes: Array<Organization>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type OrganizationSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: OrganizationSortField;
};

export enum OrganizationSortField {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME'
}

export type Query = {
  __typename?: 'Query';
  /** Get info about authenticated user. */
  authUser: User;
  /** Find single directory. */
  directory: Directory;
  /** Find single file by ID with directory and structure info. */
  file: File;
  /** Find single file_conversion */
  fileConversion: FileConversionModel;
  /** Find top contextually similar files based on selected INDEXED PDF files. */
  findSimilarFiles: Array<SimilarFile>;
  /** Get paginated list of annotations for a document. */
  getDocumentAnnotations: AnnotationPagination;
  /** Find single organization. */
  organization: Organization;
  /** Find organizations list. */
  organizations: OrganizationPagination;
  /** Search files in structure by name */
  searchFiles: SearchFileResultPagination;
  /** Find single stage */
  stage: Stage;
  /** Find single structure. */
  structure: Structure;
  /** Find single structure revision. */
  structureRevision: StructureRevision;
  /** Find structures list. */
  structures: StructurePagination;
  /** Find single user. */
  user: User;
  /** Find users list. */
  users: UserPagination;
};


export type QueryDirectoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFileConversionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindSimilarFilesArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


export type QueryGetDocumentAnnotationsArgs = {
  documentId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AnnotationsSort>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: OrganizationSort;
};


export type QuerySearchFilesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};


export type QueryStageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStructureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStructureRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStructuresArgs = {
  editorPrivilege?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: StructureSort;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: UserSort;
};

export type RemapStructureInput = {
  /** Id of the structure to remap. */
  id: Scalars['ID']['input'];
  /** SVG polygon path of structure. */
  svgPolygonPath: Scalars['String']['input'];
};

export type RemoveOrganizationFromStructureInput = {
  /** ID of organization to remove */
  organizationId: Scalars['String']['input'];
  /** ID of structure */
  structureId: Scalars['String']['input'];
};

export type RemoveOrganizationFromStructurePayload = {
  __typename?: 'RemoveOrganizationFromStructurePayload';
  /** Indicates whether organization was removed from structure successfully. */
  success: Scalars['Boolean']['output'];
};

export type RemoveUserFromStructureInput = {
  /** ID of structure */
  structureId: Scalars['String']['input'];
  /** ID of user to remove */
  userId: Scalars['String']['input'];
};

export type RemoveUserFromStructurePayload = {
  __typename?: 'RemoveUserFromStructurePayload';
  /** Indicates whether user was removed from structure successfully. */
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordInput = {
  /** Email of the user. */
  email: Scalars['String']['input'];
};

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** Indicates whether password reset flow has started. */
  success: Scalars['Boolean']['output'];
};

export type RetryPayload = {
  __typename?: 'RetryPayload';
  /** Human readable message describing retry result. */
  message: Scalars['String']['output'];
  /** Indicates whether retry was accepted. */
  success: Scalars['Boolean']['output'];
};

export type SearchFileResult = {
  __typename?: 'SearchFileResult';
  /** Path of the compressed PDF version of the file. */
  compressedPath?: Maybe<Scalars['String']['output']>;
  /** Signed URL of the compressed PDF version of the file. */
  compressedUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the file creation. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the directory this file is in. */
  directoryId: Scalars['ID']['output'];
  /** ID of the file. */
  id: Scalars['ID']['output'];
  /** Mime type of the file. */
  mimeType: Scalars['String']['output'];
  /** Name of the file. */
  name: Scalars['String']['output'];
  /** Path to the file. */
  path: Scalars['String']['output'];
  /** Size of the file. */
  size: Scalars['Int']['output'];
  /** ID of the structure this file belongs to. */
  structureId: Scalars['ID']['output'];
  /** Url of the file. */
  url: Scalars['String']['output'];
};

export type SearchFileResultPagination = {
  __typename?: 'SearchFileResultPagination';
  /** List of nodes that matched the query. */
  nodes: Array<SearchFileResult>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type SendContactEmailInput = {
  /** Email of the sender. */
  email: Scalars['String']['input'];
  /** Message content that should be sent. */
  message: Scalars['String']['input'];
  /** Name of the sender. */
  name: Scalars['String']['input'];
};

export type SendContactEmailPayload = {
  __typename?: 'SendContactEmailPayload';
  /** Indicates whether email was sent successfully. */
  success: Scalars['Boolean']['output'];
};

export type SetNewPasswordInput = {
  /** New password. */
  newPassword: Scalars['String']['input'];
  /** SetNew password token of the user. */
  resetPasswordToken: Scalars['String']['input'];
};

export type SetNewPasswordPayload = {
  __typename?: 'SetNewPasswordPayload';
  /** Token that should be passed with following requests to authenticate user. */
  token: Scalars['String']['output'];
  /** Logged user. */
  user: User;
};

export type SetStageAsExecutiveInput = {
  /** ID of stage to set as executive. */
  id: Scalars['ID']['input'];
};

export type SetStageAsExecutivePayload = {
  __typename?: 'SetStageAsExecutivePayload';
  stage: Stage;
};

export type SimilarFile = {
  __typename?: 'SimilarFile';
  /** Raw AI metadata JSON string generated from the source PDF (temporary debug field). */
  aiMetadata?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the similar file creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Name of the directory that contains the similar file. */
  directoryName?: Maybe<Scalars['String']['output']>;
  /** ID of the similar file. */
  fileId: Scalars['ID']['output'];
  /** Name of the similar file. */
  fileName: Scalars['String']['output'];
  /** URL pointing to the similar file. */
  fileUrl: Scalars['String']['output'];
  /** Similarity score in range 0-100 after internal normalisation (higher means more similar within this result set). */
  similarityScore: Scalars['Float']['output'];
  /** Name of the stage the similar file belongs to. */
  stageName?: Maybe<Scalars['String']['output']>;
  /** Name of the stage revision the similar file belongs to. */
  stageRevisionName?: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type Stage = {
  __typename?: 'Stage';
  /** Timestamp of the stage creation. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the stage. */
  id: Scalars['ID']['output'];
  /** Name Indicates whether stage is executive. */
  isExecutive: Scalars['Boolean']['output'];
  /** Name of the stage. */
  name: Scalars['String']['output'];
  /** Revisions of the stage. */
  revisions: StageRevisionPagination;
};


export type StageRevisionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: StageRevisionSort;
};

export type StagePagination = {
  __typename?: 'StagePagination';
  /** List of nodes that matched the query. */
  nodes: Array<Stage>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type StageRevision = {
  __typename?: 'StageRevision';
  /** Timestamp of the stage revision creation. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the stage revision. */
  id: Scalars['ID']['output'];
  /** Name of the stage revision. */
  name: Scalars['String']['output'];
  /** Root directory of the stage revision. */
  rootDirectory: Directory;
  /** Stage related to the stage revision. */
  stage: Stage;
};

export type StageRevisionPagination = {
  __typename?: 'StageRevisionPagination';
  /** List of nodes that matched the query. */
  nodes: Array<StageRevision>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type StageRevisionSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: StageRevisionSortField;
};

export enum StageRevisionSortField {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME'
}

export type StageSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: StageSortField;
};

export enum StageSortField {
  CREATED_AT = 'CREATED_AT',
  IS_EXECUTIVE = 'IS_EXECUTIVE',
  NAME = 'NAME'
}

export type StructIdInput = {
  /** Id of the struct to add. */
  id: Scalars['ID']['input'];
};

export type Structure = {
  __typename?: 'Structure';
  /** Ancestors of the structure from the oldest to the newest. */
  ancestors: Array<Structure>;
  /** Background file convert status status of the structure. */
  backgroundFileConvertStatus?: Maybe<StructureConvertedFileStatus>;
  /** Background file convert url of the structure. */
  backgroundFileConvertUrl?: Maybe<Scalars['String']['output']>;
  /** Background staged file convert status status of the structure. */
  backgroundStagedFileConvertStatus?: Maybe<StructureConvertedFileStatus>;
  /** Background staged file convert url of the structure. */
  backgroundStagedFileConvertUrl?: Maybe<Scalars['String']['output']>;
  /** Children structures of the structure. */
  children: StructurePagination;
  /** Timestamp of the structure creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the structure. */
  description: Scalars['String']['output'];
  /** Finishing scheme file url of the structure. */
  finishingSchemeUrl?: Maybe<Scalars['String']['output']>;
  /** Floor number of the structure (STOREY only). */
  floorNumber?: Maybe<Scalars['Int']['output']>;
  /** ID of the structure. */
  id: Scalars['ID']['output'];
  /** Interactive file convert status status of the structure. */
  interactiveFileConvertStatus?: Maybe<StructureConvertedFileStatus>;
  /** Interactive file convert url of the structure. */
  interactiveFileConvertUrl?: Maybe<Scalars['String']['output']>;
  /** Interactive staged file convert status status of the structure. */
  interactiveStagedFileConvertStatus?: Maybe<StructureConvertedFileStatus>;
  /** Interactive staged file convert url of the structure. */
  interactiveStagedFileConvertUrl?: Maybe<Scalars['String']['output']>;
  /** Is the user an editor of the structure */
  isAuthUserEditor: Scalars['Boolean']['output'];
  /** Name of the structure. */
  name: Scalars['String']['output'];
  /** Organizations assigned to the structure (admin only). */
  organizations: OrganizationPagination;
  /** Structure to which current structure referes to. */
  reference?: Maybe<Structure>;
  /** Structures that point to the current structure */
  referenceBy: Array<Structure>;
  /** List of structure revisions */
  revisions: StructureRevisionPagination;
  /** List of structure stages */
  stages: StagePagination;
  /** SVG polygon path of the structure. */
  svgPolygonPath?: Maybe<Scalars['String']['output']>;
  /** Converted file status of the structure. */
  type: StructureType;
  /** Users assigned to the structure. */
  users: UserPagination;
  /** Timestamp when the OpenAI vector store was created for this structure. */
  vectorStoreCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** OpenAI vector store ID assigned to this structure (root structures only). */
  vectorStoreId?: Maybe<Scalars['String']['output']>;
};


export type StructureChildrenArgs = {
  editorPrivilege?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: StructureSort;
};


export type StructureOrganizationsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: OrganizationSort;
};


export type StructureRevisionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: StructureRevisionsSort;
};


export type StructureStagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: StageSort;
};


export type StructureUsersArgs = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: UserSort;
};

export enum StructureConvertedFileStatus {
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS'
}

export enum StructureFileType {
  MAIN = 'MAIN',
  STAGED = 'STAGED'
}

export type StructurePagination = {
  __typename?: 'StructurePagination';
  /** List of nodes that matched the query. */
  nodes: Array<Structure>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type StructurePointer = {
  /** Floor number of the structure. */
  floorNumber?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the structure. */
  name: Scalars['String']['input'];
  /** Id of the parent of structure pointer. */
  parentId: Scalars['ID']['input'];
  /** SVG polygon path of structure. */
  svgPolygonPath?: InputMaybe<Scalars['String']['input']>;
};

export type StructureRevision = {
  __typename?: 'StructureRevision';
  /** Timestamp of the structure revision creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Files assigned to the structure revision. */
  files: Array<StructureRevisionFile>;
  /** ID of the structure. */
  id: Scalars['ID']['output'];
  /** Name of the structure revision. */
  name: Scalars['String']['output'];
  /** Structure related to the structure revision. */
  structure: Structure;
};

export type StructureRevisionFile = {
  __typename?: 'StructureRevisionFile';
  /** Name of the file. */
  fileName: Scalars['String']['output'];
  /** Url of the file. */
  fileUrl: Scalars['String']['output'];
  /** ID of the structure revision file. */
  id: Scalars['ID']['output'];
};

export type StructureRevisionPagination = {
  __typename?: 'StructureRevisionPagination';
  /** List of nodes that matched the query. */
  nodes: Array<StructureRevision>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type StructureRevisionsSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: StructureRevisionsSortField;
};

export enum StructureRevisionsSortField {
  CREATED_AT = 'CREATED_AT'
}

export type StructureSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: StructureSortField;
};

export enum StructureSortField {
  CREATED_AT = 'CREATED_AT',
  FLOOR_NUMBER = 'FLOOR_NUMBER',
  NAME = 'NAME'
}

export enum StructureType {
  COORDINATION_MODE = 'COORDINATION_MODE',
  GENERAL_MODE = 'GENERAL_MODE',
  LAYER = 'LAYER',
  STOREY = 'STOREY'
}

export type SwapStructureFileInput = {
  /** ID of structure to swap files. */
  id: Scalars['ID']['input'];
  /** IDs of the structs to remap. */
  structuresToRemap: Array<RemapStructureInput>;
};

export type SwapStructureFilePayload = {
  __typename?: 'SwapStructureFilePayload';
  structure: Structure;
};

export type UpdateAnnotationInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  mentions?: InputMaybe<Array<MentionInput>>;
  position?: InputMaybe<AnnotationPositionInput>;
};

export type UpdateAnnotationPayload = {
  __typename?: 'UpdateAnnotationPayload';
  annotation: Annotation;
};

export type UpdateDirectoryInput = {
  /** ID of the directory to update. */
  id: Scalars['ID']['input'];
  /** Name of the directory. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDirectoryPayload = {
  __typename?: 'UpdateDirectoryPayload';
  directory: Directory;
};

export type UpdateFileInput = {
  /** ID of the file to update. */
  id: Scalars['ID']['input'];
  /** Name of the file. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFilePayload = {
  __typename?: 'UpdateFilePayload';
  file: File;
};

export type UpdateOrganizationInput = {
  /** ID of organization to update. */
  id: Scalars['ID']['input'];
  /** Name of the organization. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  organization: Organization;
};

export type UpdateStageInput = {
  /** ID of stage to update. */
  id: Scalars['ID']['input'];
  /** Name of the stage. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStagePayload = {
  __typename?: 'UpdateStagePayload';
  stage: Stage;
};

export type UpdateStageRevisionInput = {
  /** ID of stage revision to update. */
  id: Scalars['ID']['input'];
  /** Name of the stage revision. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStageRevisionPayload = {
  __typename?: 'UpdateStageRevisionPayload';
  stageRevision: StageRevision;
};

export type UpdateStructureFilesInput = {
  /** Uploaded background file token to assign into structure. */
  backgroundFileUploadToken: Scalars['String']['input'];
  /** When true, updates the files prepared for manual swapping/remapping. When false, updates the currently active files. */
  fileType?: StructureFileType;
  /** ID of structure to update. */
  id: Scalars['ID']['input'];
  /** Uploaded interactive file token to assign into structure. */
  interactiveFileUploadToken: Scalars['String']['input'];
};

export type UpdateStructureFilesPayload = {
  __typename?: 'UpdateStructureFilesPayload';
  structure: Structure;
};

export type UpdateStructureFinishingSchemeInput = {
  /** Uploaded file token to assign into structure as finishing scheme. Set to null to remove file. */
  finishingSchemeFileUploadToken?: InputMaybe<Scalars['String']['input']>;
  /** ID of structure to update. */
  id: Scalars['ID']['input'];
};

export type UpdateStructureFinishingSchemePayload = {
  __typename?: 'UpdateStructureFinishingSchemePayload';
  structure: Structure;
};

export type UpdateStructureInput = {
  /** Description of the structure. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Floor number of the structure. */
  floorNumber?: InputMaybe<Scalars['Float']['input']>;
  /** ID of structure to update. */
  id: Scalars['ID']['input'];
  /** Name of the structure. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStructurePayload = {
  __typename?: 'UpdateStructurePayload';
  structure: Structure;
};

export type UpdateStructureRevisionInput = {
  /** ID of structure revision to update. */
  id: Scalars['ID']['input'];
  /** Name of the structure revision. */
  name: Scalars['String']['input'];
};

export type UpdateStructureRevisionPayload = {
  __typename?: 'UpdateStructureRevisionPayload';
  structureRevision: StructureRevision;
};

export type UpdateUserInput = {
  /** IDs of the structs that user will administrate. */
  editorOfStrucks?: InputMaybe<Array<UpdateUserStructIdInput>>;
  /** Email of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the user. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** ID of user to update. */
  id: Scalars['ID']['input'];
  /** Is new user admin. */
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization assigned to the user. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user: User;
};

export type UpdateUserStructIdInput = {
  /** Id of the struct to add. */
  id: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  /** Timestamp of the user creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Email of the user. */
  email: Scalars['String']['output'];
  /** Full name of the user. */
  fullName: Scalars['String']['output'];
  /** ID of the user. */
  id: Scalars['ID']['output'];
  /** Indicates whether user is an admin. */
  isAdmin: Scalars['Boolean']['output'];
  /** Indicates whether user is already onboarded. */
  isOnboarded: Scalars['Boolean']['output'];
  /** Organization assigned to the user. */
  organization?: Maybe<Organization>;
  /** List of structures user is assigned to. */
  structures: StructurePagination;
};


export type UserStructuresArgs = {
  editorPrivilege?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: StructureSort;
};

export type UserPagination = {
  __typename?: 'UserPagination';
  /** List of nodes that matched the query. */
  nodes: Array<User>;
  /** The total number of results, regardless of page and perPage arguments. */
  totalCount: Scalars['Float']['output'];
};

export type UserSort = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort results by. */
  field: UserSortField;
};

export enum UserSortField {
  CREATED_AT = 'CREATED_AT',
  FULL_NAME = 'FULL_NAME'
}

export type SearchFilesQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFilesQuery = { __typename?: 'Query', searchFiles: { __typename?: 'SearchFileResultPagination', totalCount: number, nodes: Array<{ __typename?: 'SearchFileResult', id: string, name: string, size: number, mimeType: string, path: string, url: string, compressedPath?: string | null, compressedUrl?: string | null, createdAt: any, structureId: string, directoryId: string }> } };

export type CreateAnnotationMutationVariables = Exact<{
  input: CreateAnnotationInput;
}>;


export type CreateAnnotationMutation = { __typename?: 'Mutation', createAnnotation: { __typename?: 'CreateAnnotationPayload', annotation: { __typename?: 'Annotation', id: string, documentId: string, content: string, pageNumber: number, authorId: string, createdAt: any, isReply: boolean, position: { __typename?: 'AnnotationPosition', x: number, y: number, width: number, height: number }, parent?: { __typename?: 'Annotation', id: string } | null, replies: Array<{ __typename?: 'Annotation', id: string, content: string, authorId: string, isReply: boolean, parent?: { __typename?: 'Annotation', id: string } | null }> } } };

export type DeleteAnnotationMutationVariables = Exact<{
  input: DeleteAnnotationInput;
}>;


export type DeleteAnnotationMutation = { __typename?: 'Mutation', deleteAnnotation: { __typename?: 'DeleteAnnotationPayload', success: boolean } };

export type UpdateAnnotationMutationVariables = Exact<{
  input: UpdateAnnotationInput;
}>;


export type UpdateAnnotationMutation = { __typename?: 'Mutation', updateAnnotation: { __typename?: 'UpdateAnnotationPayload', annotation: { __typename?: 'Annotation', id: string, documentId: string, content: string, pageNumber: number, authorId: string, createdAt: any, isReply: boolean, position: { __typename?: 'AnnotationPosition', x: number, y: number, width: number, height: number }, parent?: { __typename?: 'Annotation', id: string } | null, replies: Array<{ __typename?: 'Annotation', id: string, content: string, authorId: string, isReply: boolean, parent?: { __typename?: 'Annotation', id: string } | null }> } } };

export type CreateDirectoryMutationVariables = Exact<{
  input: CreateDirectoryInput;
}>;


export type CreateDirectoryMutation = { __typename?: 'Mutation', createDirectory: { __typename?: 'CreateDirectoryPayload', directory: { __typename?: 'Directory', id: string } } };

export type UpdateDirectoryMutationVariables = Exact<{
  input: UpdateDirectoryInput;
}>;


export type UpdateDirectoryMutation = { __typename?: 'Mutation', updateDirectory: { __typename?: 'UpdateDirectoryPayload', directory: { __typename?: 'Directory', id: string, name?: string | null } } };

export type CreateDirectoryFileMutationVariables = Exact<{
  input: CreateFileInput;
}>;


export type CreateDirectoryFileMutation = { __typename?: 'Mutation', createFile: { __typename?: 'CreateFilePayload', file: { __typename?: 'File', id: string } } };

export type DeleteDirectoryMutationVariables = Exact<{
  input: DeleteDirectoryInput;
}>;


export type DeleteDirectoryMutation = { __typename?: 'Mutation', deleteDirectory: { __typename?: 'DeleteDirectoryPayload', success: boolean } };

export type DeleteDirectoryFileMutationVariables = Exact<{
  input: DeleteFileInput;
}>;


export type DeleteDirectoryFileMutation = { __typename?: 'Mutation', deleteFile: { __typename?: 'DeleteFilePayload', success: boolean } };

export type UpdateDirectoryFileMutationVariables = Exact<{
  input: UpdateFileInput;
}>;


export type UpdateDirectoryFileMutation = { __typename?: 'Mutation', updateFile: { __typename?: 'UpdateFilePayload', file: { __typename?: 'File', id: string, name: string } } };

export type ArchiveDirectoryMutationVariables = Exact<{
  input: ArchiveDirectoryInput;
}>;


export type ArchiveDirectoryMutation = { __typename?: 'Mutation', archiveDirectory: { __typename?: 'ArchiveDirectoryPayload', key: string } };

export type DeleteFileMutationMutationVariables = Exact<{
  input: DeleteFileInput;
}>;


export type DeleteFileMutationMutation = { __typename?: 'Mutation', deleteFile: { __typename?: 'DeleteFilePayload', success: boolean } };

export type ConvertSvgMutationVariables = Exact<{
  input: ConvertSvgInput;
}>;


export type ConvertSvgMutation = { __typename?: 'Mutation', convertSvg: { __typename?: 'ConvertSvgPayload', fileConversion: { __typename?: 'FileConversionModel', convertedFileUrl?: string | null, jobStatus?: string | null, id: string } } };

export type RetryFileIndexingMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type RetryFileIndexingMutation = { __typename?: 'Mutation', retryFileIndexing: { __typename?: 'RetryPayload', success: boolean, message: string } };

export type CreateOrganizationMutationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string, createdAt: any } } };

export type UpdateOrganizationMutationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string, createdAt: any } } };

export type DeleteOrganizationMutationMutationVariables = Exact<{
  input: DeleteOrganizationInput;
}>;


export type DeleteOrganizationMutationMutation = { __typename?: 'Mutation', deleteOrganization: { __typename?: 'DeleteOrganizationPayload', success: boolean } };

export type CreateStageMutationMutationVariables = Exact<{
  input: CreateStageInput;
}>;


export type CreateStageMutationMutation = { __typename?: 'Mutation', createStage: { __typename?: 'CreateStagePayload', stage: { __typename?: 'Stage', id: string } } };

export type UpdateStageMutationMutationVariables = Exact<{
  input: UpdateStageInput;
}>;


export type UpdateStageMutationMutation = { __typename?: 'Mutation', updateStage: { __typename?: 'UpdateStagePayload', stage: { __typename?: 'Stage', id: string } } };

export type DeleteStageMutationMutationVariables = Exact<{
  input: DeleteStageInput;
}>;


export type DeleteStageMutationMutation = { __typename?: 'Mutation', deleteStage: { __typename?: 'DeleteStagePayload', success: boolean } };

export type CreateStageRevisionMutationMutationVariables = Exact<{
  input: CreateStageRevisionInput;
}>;


export type CreateStageRevisionMutationMutation = { __typename?: 'Mutation', createStageRevision: { __typename?: 'CreateStageRevisionPayload', stageRevision: { __typename?: 'StageRevision', id: string } } };

export type DeleteStageRevisionMutationMutationVariables = Exact<{
  input: DeleteStageRevisionInput;
}>;


export type DeleteStageRevisionMutationMutation = { __typename?: 'Mutation', deleteStageRevision: { __typename?: 'DeleteStageRevisionPayload', success: boolean } };

export type SetStageAsExecutiveMutationMutationVariables = Exact<{
  input: SetStageAsExecutiveInput;
}>;


export type SetStageAsExecutiveMutationMutation = { __typename?: 'Mutation', setStageAsExecutive: { __typename?: 'SetStageAsExecutivePayload', stage: { __typename?: 'Stage', id: string } } };

export type UpdateStageRevisionMutationVariables = Exact<{
  input: UpdateStageRevisionInput;
}>;


export type UpdateStageRevisionMutation = { __typename?: 'Mutation', updateStageRevision: { __typename?: 'UpdateStageRevisionPayload', stageRevision: { __typename?: 'StageRevision', id: string } } };

export type CreateFileUploadMutationMutationVariables = Exact<{
  input: CreateFileUploadInput;
}>;


export type CreateFileUploadMutationMutation = { __typename?: 'Mutation', createFileUpload: { __typename?: 'CreateFileUploadPayload', url: string, uploadToken: string, fields: Array<{ __typename?: 'Entry', key: string, value: string }> } };

export type CreateStructureMutationMutationVariables = Exact<{
  input: CreateStructureInput;
}>;


export type CreateStructureMutationMutation = { __typename?: 'Mutation', createStructure: { __typename?: 'CreateStructurePayload', structure: { __typename?: 'Structure', id: string } } };

export type CopyStructuresMutationVariables = Exact<{
  input: CopyStructureInput;
}>;


export type CopyStructuresMutation = { __typename?: 'Mutation', copyStructures: { __typename?: 'CopyStructuresPayload', success: boolean } };

export type UpdateStructureMutationMutationVariables = Exact<{
  input: UpdateStructureInput;
}>;


export type UpdateStructureMutationMutation = { __typename?: 'Mutation', updateStructure: { __typename?: 'UpdateStructurePayload', structure: { __typename?: 'Structure', id: string } } };

export type DeleteStructureMutationMutationVariables = Exact<{
  input: DeleteStructureInput;
}>;


export type DeleteStructureMutationMutation = { __typename?: 'Mutation', deleteStructure: { __typename?: 'DeleteStructurePayload', success: boolean } };

export type CreateStructureReferencesMutationVariables = Exact<{
  input: CreateReferencesToStructureInput;
}>;


export type CreateStructureReferencesMutation = { __typename?: 'Mutation', createStructureReferences: { __typename?: 'CreateStructureReferencesPayload', success: boolean } };

export type AddUserToStructureMutationMutationVariables = Exact<{
  input: AddUserToStructureInput;
}>;


export type AddUserToStructureMutationMutation = { __typename?: 'Mutation', addUserToStructure: { __typename?: 'AddUserToStructurePayload', success: boolean } };

export type AddOrganizationToStructureMutationMutationVariables = Exact<{
  input: AddOrganizationToStructureInput;
}>;


export type AddOrganizationToStructureMutationMutation = { __typename?: 'Mutation', addOrganizationToStructure: { __typename?: 'AddOrganizationToStructurePayload', success: boolean } };

export type RemoveOrganizationFromStructureMutationVariables = Exact<{
  input: RemoveOrganizationFromStructureInput;
}>;


export type RemoveOrganizationFromStructureMutation = { __typename?: 'Mutation', removeOrganizationFromStructure: { __typename?: 'RemoveOrganizationFromStructurePayload', success: boolean } };

export type RemoveUserFromStructureMutationVariables = Exact<{
  input: RemoveUserFromStructureInput;
}>;


export type RemoveUserFromStructureMutation = { __typename?: 'Mutation', removeUserFromStructure: { __typename?: 'RemoveUserFromStructurePayload', success: boolean } };

export type UpdateStructureFilesMutationMutationVariables = Exact<{
  input: UpdateStructureFilesInput;
}>;


export type UpdateStructureFilesMutationMutation = { __typename?: 'Mutation', updateStructureFiles: { __typename?: 'UpdateStructureFilesPayload', structure: { __typename?: 'Structure', id: string } } };

export type UpdateFileMutationVariables = Exact<{
  input: UpdateStructureFinishingSchemeInput;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateStructureFinishingScheme: { __typename?: 'UpdateStructureFinishingSchemePayload', structure: { __typename?: 'Structure', id: string } } };

export type DeleteStructureRevisionMutationMutationVariables = Exact<{
  input: DeleteStructureRevisionInput;
}>;


export type DeleteStructureRevisionMutationMutation = { __typename?: 'Mutation', deleteStructureRevision: { __typename?: 'DeleteStructureRevisionPayload', success: boolean } };

export type CreateStructureRevisionMutationMutationVariables = Exact<{
  input: CreateStructureRevisionInput;
}>;


export type CreateStructureRevisionMutationMutation = { __typename?: 'Mutation', createStructureRevision: { __typename?: 'CreateStructureRevisionPayload', structureRevision: { __typename?: 'StructureRevision', id: string } } };

export type UpdateStructureRevisionMutationVariables = Exact<{
  input: UpdateStructureRevisionInput;
}>;


export type UpdateStructureRevisionMutation = { __typename?: 'Mutation', updateStructureRevision: { __typename?: 'UpdateStructureRevisionPayload', structureRevision: { __typename?: 'StructureRevision', id: string } } };

export type DeleteSubtreeStructuresMutationVariables = Exact<{
  input: DeleteSubtreeStructuresInput;
}>;


export type DeleteSubtreeStructuresMutation = { __typename?: 'Mutation', deleteSubtreeStructures: { __typename?: 'DeleteSubtreeStructuresPayload', success: boolean } };

export type SwapStructureFileMutationVariables = Exact<{
  input: SwapStructureFileInput;
}>;


export type SwapStructureFileMutation = { __typename?: 'Mutation', swapStructureFile: { __typename?: 'SwapStructureFilePayload', structure: { __typename?: 'Structure', id: string } } };

export type DeleteStructureFilesMutationVariables = Exact<{
  input: DeleteStructureFilesInput;
}>;


export type DeleteStructureFilesMutation = { __typename?: 'Mutation', deleteStructureFiles: { __typename?: 'DeleteStructureFilesPayload', structure: { __typename?: 'Structure', id: string } } };

export type CreateStructureVectorStoreMutationVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type CreateStructureVectorStoreMutation = { __typename?: 'Mutation', createStructureVectorStore: { __typename?: 'Structure', id: string, vectorStoreId?: string | null, vectorStoreCreatedAt?: any | null } };

export type BatchIndexExistingFilesMutationVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BatchIndexExistingFilesMutation = { __typename?: 'Mutation', batchIndexExistingFiles: { __typename?: 'BatchIndexPayload', totalFiles: number, queuedFiles: number, alreadyIndexed: number, errors: Array<string> } };

export type LoginMutationMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutationMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginPayload', token: string, user: { __typename?: 'User', id: string, email: string, fullName: string, isAdmin: boolean, isOnboarded: boolean, organization?: { __typename?: 'Organization', id: string, name: string } | null } } };

export type ResetPasswordMutationMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutationMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordPayload', success: boolean } };

export type FinishOnboardingMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishOnboardingMutationMutation = { __typename?: 'Mutation', finishOnboarding: { __typename?: 'FinishOnboardingPayload', user: { __typename?: 'User', id: string, email: string, fullName: string, isAdmin: boolean, isOnboarded: boolean, organization?: { __typename?: 'Organization', id: string, name: string } | null } } };

export type CreateUserMutationMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutationMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserPayload', user: { __typename?: 'User', id: string, email: string } } };

export type SetNewPasswordMutationMutationVariables = Exact<{
  input: SetNewPasswordInput;
}>;


export type SetNewPasswordMutationMutation = { __typename?: 'Mutation', setNewPassword: { __typename?: 'SetNewPasswordPayload', token: string, user: { __typename?: 'User', id: string, email: string } } };

export type UpdateUserMutationMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutationMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user: { __typename?: 'User', id: string, email: string, fullName: string, isAdmin: boolean, isOnboarded: boolean, organization?: { __typename?: 'Organization', id: string, name: string } | null } } };

export type DeleteUserMutationMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserMutationMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserPayload', success: boolean } };

export type FindSimilarFilesQueryVariables = Exact<{
  fileIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FindSimilarFilesQuery = { __typename?: 'Query', findSimilarFiles: Array<{ __typename?: 'SimilarFile', fileId: string, fileName: string, similarityScore: number, fileUrl: string, createdAt: any, directoryName?: string | null, stageName?: string | null, stageRevisionName?: string | null, aiMetadata?: string | null }> };

export type GetDocumentAnnotationsQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AnnotationsSort>;
}>;


export type GetDocumentAnnotationsQuery = { __typename?: 'Query', getDocumentAnnotations: { __typename?: 'AnnotationPagination', totalCount: number, nodes: Array<{ __typename?: 'Annotation', id: string, documentId: string, content: string, pageNumber: number, authorId: string, authorFullName?: string | null, createdAt: any, isReply: boolean, position: { __typename?: 'AnnotationPosition', x: number, y: number, width: number, height: number }, parent?: { __typename?: 'Annotation', id: string } | null, replies: Array<{ __typename?: 'Annotation', id: string, content: string, authorId: string, authorFullName?: string | null, isReply: boolean, parent?: { __typename?: 'Annotation', id: string } | null, mentions: Array<{ __typename?: 'Mention', id: string, value: string, email: string }> }>, mentions: Array<{ __typename?: 'Mention', id: string, value: string, email: string }> }> } };

export type GetDirectoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filePage?: InputMaybe<Scalars['Int']['input']>;
  filePerPage?: InputMaybe<Scalars['Int']['input']>;
  childrenSort?: InputMaybe<DirectorySort>;
  filesSort?: InputMaybe<FileSort>;
}>;


export type GetDirectoryQuery = { __typename?: 'Query', directory: { __typename?: 'Directory', name?: string | null, id: string, ancestors: Array<{ __typename?: 'Directory', id: string, name?: string | null, stageRevision: { __typename?: 'StageRevision', rootDirectory: { __typename?: 'Directory', id: string, name?: string | null } } }>, stageRevision: { __typename?: 'StageRevision', createdAt: any, name: string, id: string, rootDirectory: { __typename?: 'Directory', id: string, name?: string | null }, stage: { __typename?: 'Stage', id: string, name: string } }, children: { __typename?: 'DirectoryPagination', totalCount: number, nodes: Array<{ __typename?: 'Directory', name?: string | null, id: string, stageRevision: { __typename?: 'StageRevision', name: string, id: string, rootDirectory: { __typename?: 'Directory', name?: string | null, id: string }, stage: { __typename?: 'Stage', id: string, name: string } } }> }, files: { __typename?: 'FilePagination', totalCount: number, nodes: Array<{ __typename?: 'File', mimeType: string, name: string, id: string, url: string, compressedPath?: string | null, compressedUrl?: string | null, vectorIndexStatus?: FileVectorIndexStatus | null, vectorIndexError?: string | null }> } } };

export type GetRootDirectoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRootDirectoryQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', name: string, id: string, type: StructureType, stages: { __typename?: 'StagePagination', nodes: Array<{ __typename?: 'Stage', name: string, id: string, revisions: { __typename?: 'StageRevisionPagination', nodes: Array<{ __typename?: 'StageRevision', name: string, createdAt: any, rootDirectory: { __typename?: 'Directory', id: string, createdAt: any } }> } }> } } };

export type GetStagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StageSort>;
}>;


export type GetStagesQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', stages: { __typename?: 'StagePagination', totalCount: number, nodes: Array<{ __typename?: 'Stage', id: string, createdAt: any, name: string, isExecutive: boolean, revisions: { __typename?: 'StageRevisionPagination', nodes: Array<{ __typename?: 'StageRevision', id: string, name: string, createdAt: any, rootDirectory: { __typename?: 'Directory', id: string } }> } }> } } };

export type GetRevisionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StageRevisionSort>;
}>;


export type GetRevisionsQuery = { __typename?: 'Query', stage: { __typename?: 'Stage', id: string, name: string, revisions: { __typename?: 'StageRevisionPagination', totalCount: number, nodes: Array<{ __typename?: 'StageRevision', id: string, createdAt: any, name: string, rootDirectory: { __typename?: 'Directory', id: string } }> } } };

export type FileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileQuery = { __typename?: 'Query', file: { __typename?: 'File', id: string, name: string, mimeType: string, url: string, compressedPath?: string | null, compressedUrl?: string | null, structureId?: string | null, directory?: { __typename?: 'Directory', id: string } | null } };

export type FileConversionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileConversionQuery = { __typename?: 'Query', fileConversion: { __typename?: 'FileConversionModel', convertedFileUrl?: string | null, jobStatus?: string | null } };

export type GetOrganizationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<OrganizationSort>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationPagination', totalCount: number, nodes: Array<{ __typename?: 'Organization', name: string, id: string, createdAt: any }> } };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', name: string } };

export type GetStructureStagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StageSort>;
}>;


export type GetStructureStagesQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', stages: { __typename?: 'StagePagination', totalCount: number, nodes: Array<{ __typename?: 'Stage', id: string, createdAt: any, name: string, isExecutive: boolean, revisions: { __typename?: 'StageRevisionPagination', nodes: Array<{ __typename?: 'StageRevision', id: string, name: string, rootDirectory: { __typename?: 'Directory', id: string } }> } }> } } };

export type GetStageRevisionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StageRevisionSort>;
}>;


export type GetStageRevisionsQuery = { __typename?: 'Query', stage: { __typename?: 'Stage', id: string, name: string, revisions: { __typename?: 'StageRevisionPagination', totalCount: number, nodes: Array<{ __typename?: 'StageRevision', id: string, createdAt: any, name: string, rootDirectory: { __typename?: 'Directory', id: string } }> } } };

export type GetStructuresQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StructureSort>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructuresQuery = { __typename?: 'Query', structures: { __typename?: 'StructurePagination', totalCount: number, nodes: Array<{ __typename?: 'Structure', name: string, isAuthUserEditor: boolean, createdAt: any, id: string, backgroundFileConvertUrl?: string | null, interactiveFileConvertUrl?: string | null, vectorStoreId?: string | null }> } };

export type GetStructureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStructureQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', name: string, type: StructureType, backgroundFileConvertUrl?: string | null, backgroundFileConvertStatus?: StructureConvertedFileStatus | null, interactiveFileConvertUrl?: string | null, interactiveFileConvertStatus?: StructureConvertedFileStatus | null, backgroundStagedFileConvertStatus?: StructureConvertedFileStatus | null, backgroundStagedFileConvertUrl?: string | null, interactiveStagedFileConvertStatus?: StructureConvertedFileStatus | null, interactiveStagedFileConvertUrl?: string | null, finishingSchemeUrl?: string | null, floorNumber?: number | null, id: string, isAuthUserEditor: boolean, svgPolygonPath?: string | null, vectorStoreId?: string | null, vectorStoreCreatedAt?: any | null, ancestors: Array<{ __typename?: 'Structure', id: string, name: string, type: StructureType, vectorStoreId?: string | null }> } };

export type GetStructureOrganizationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  organizationsPerPage?: InputMaybe<Scalars['Int']['input']>;
  organizationsPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStructureOrganizationsQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', organizations: { __typename?: 'OrganizationPagination', totalCount: number, nodes: Array<{ __typename?: 'Organization', id: string, name: string }> } } };

export type GetStructureUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userPerPage?: InputMaybe<Scalars['Int']['input']>;
  usersPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSort>;
}>;


export type GetStructureUsersQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', users: { __typename?: 'UserPagination', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, fullName: string, email: string, organization?: { __typename?: 'Organization', name: string } | null }> } } };

export type GetStructurePreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StructureSort>;
}>;


export type GetStructurePreviewQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', interactiveFileConvertUrl?: string | null, backgroundFileConvertUrl?: string | null, backgroundFileConvertStatus?: StructureConvertedFileStatus | null, interactiveFileConvertStatus?: StructureConvertedFileStatus | null, finishingSchemeUrl?: string | null, svgPolygonPath?: string | null, floorNumber?: number | null, id: string, name: string, type: StructureType, description: string, ancestors: Array<{ __typename?: 'Structure', id: string, description: string }>, children: { __typename?: 'StructurePagination', totalCount: number, nodes: Array<{ __typename?: 'Structure', id: string, name: string, floorNumber?: number | null, svgPolygonPath?: string | null, description: string, backgroundFileConvertUrl?: string | null, interactiveFileConvertUrl?: string | null, finishingSchemeUrl?: string | null, type: StructureType, ancestors: Array<{ __typename?: 'Structure', id: string, name: string, description: string }>, reference?: { __typename?: 'Structure', id: string, name: string, svgPolygonPath?: string | null, description: string, type: StructureType, ancestors: Array<{ __typename?: 'Structure', id: string, name: string }> } | null }> } } };

export type GetStructureReferencesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStructureReferencesQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, name: string, reference?: { __typename?: 'Structure', id: string, name: string, type: StructureType, ancestors: Array<{ __typename?: 'Structure', id: string, name: string, type: StructureType }> } | null, referenceBy: Array<{ __typename?: 'Structure', id: string, name: string, type: StructureType, ancestors: Array<{ __typename?: 'Structure', id: string, name: string, type: StructureType }> }>, ancestors: Array<{ __typename?: 'Structure', id: string, name: string, type: StructureType }> } };

export type GetNestedStructureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sort?: InputMaybe<StructureSort>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNestedStructureQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', name: string, id: string, description: string, backgroundFileConvertUrl?: string | null, backgroundFileConvertStatus?: StructureConvertedFileStatus | null, interactiveFileConvertUrl?: string | null, interactiveFileConvertStatus?: StructureConvertedFileStatus | null, backgroundStagedFileConvertStatus?: StructureConvertedFileStatus | null, backgroundStagedFileConvertUrl?: string | null, interactiveStagedFileConvertStatus?: StructureConvertedFileStatus | null, interactiveStagedFileConvertUrl?: string | null, svgPolygonPath?: string | null, finishingSchemeUrl?: string | null, type: StructureType, ancestors: Array<{ __typename?: 'Structure', name: string, id: string }>, children: { __typename?: 'StructurePagination', totalCount: number, nodes: Array<{ __typename?: 'Structure', name: string, floorNumber?: number | null, svgPolygonPath?: string | null, description: string, backgroundFileConvertUrl?: string | null, interactiveFileConvertUrl?: string | null, backgroundFileConvertStatus?: StructureConvertedFileStatus | null, interactiveFileConvertStatus?: StructureConvertedFileStatus | null, backgroundStagedFileConvertStatus?: StructureConvertedFileStatus | null, backgroundStagedFileConvertUrl?: string | null, interactiveStagedFileConvertStatus?: StructureConvertedFileStatus | null, interactiveStagedFileConvertUrl?: string | null, finishingSchemeUrl?: string | null, id: string, type: StructureType, ancestors: Array<{ __typename?: 'Structure', name: string, id: string }> }> } } };

export type GetStructureRevisionListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StructureRevisionsSort>;
}>;


export type GetStructureRevisionListQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', revisions: { __typename?: 'StructureRevisionPagination', totalCount: number, nodes: Array<{ __typename?: 'StructureRevision', id: string, createdAt: any, name: string, files: Array<{ __typename?: 'StructureRevisionFile', id: string, fileName: string, fileUrl: string }>, structure: { __typename?: 'Structure', id: string, svgPolygonPath?: string | null } }> } } };

export type GetStructureAncestorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStructureAncestorsQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, name: string, type: StructureType, ancestors: Array<{ __typename?: 'Structure', name: string, id: string, type: StructureType }> } };

export type GetCurrentManageStructureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCurrentManageStructureQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, ancestors: Array<{ __typename?: 'Structure', id: string }>, children: { __typename?: 'StructurePagination', totalCount: number, nodes: Array<{ __typename?: 'Structure', name: string, id: string, svgPolygonPath?: string | null, type: StructureType, description: string, ancestors: Array<{ __typename?: 'Structure', id: string }> }> } } };

export type GetStructureChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sort?: InputMaybe<StructureSort>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStructureChildrenQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', name: string, id: string, svgPolygonPath?: string | null, type: StructureType, children: { __typename?: 'StructurePagination', totalCount: number, nodes: Array<{ __typename?: 'Structure', name: string, id: string, svgPolygonPath?: string | null, type: StructureType, floorNumber?: number | null, ancestors: Array<{ __typename?: 'Structure', name: string, id: string }>, reference?: { __typename?: 'Structure', id: string, name: string } | null }> } } };

export type GetAllUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  usersFullName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserPagination', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, createdAt: any, email: string, fullName: string, isAdmin: boolean, isOnboarded: boolean, organization?: { __typename?: 'Organization', id: string, name: string } | null }> } };

export type GetUsersListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSort>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUsersListQuery = { __typename?: 'Query', users: { __typename?: 'UserPagination', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, email: string, fullName: string, isAdmin: boolean, organization?: { __typename?: 'Organization', id: string, name: string } | null }> } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', authUser: { __typename?: 'User', id: string, createdAt: any, email: string, fullName: string, isAdmin: boolean, isOnboarded: boolean, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type GetUserStructuresQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  editorPrivilege?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserStructuresQuery = { __typename?: 'Query', user: { __typename?: 'User', structures: { __typename?: 'StructurePagination', totalCount: number, nodes: Array<{ __typename?: 'Structure', id: string, name: string }> } } };
